import axios from "axios";

const API_BASE =
  process.env.REACT_APP_API_BASE_URL || "https://modularobjects.com";

const API = `${API_BASE}/marketing/api/erp`;

function authHeader(token) {
  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
}

export async function fetchPurchaseOrders(token, params = {}) {
  const res = await axios.get(`${API}/purchase-orders`, {
    ...authHeader(token),
    params,
  });
  return res.data;
}

export async function fetchPurchaseOrderById(token, id) {
  const res = await axios.get(`${API}/purchase-orders/${id}`, authHeader(token));
  return res.data;
}

export async function createPurchaseOrder(token, data) {
  const res = await axios.post(`${API}/purchase-orders`, data, authHeader(token));
  return res.data;
}

export async function updatePurchaseOrder(token, id, data) {
  const res = await axios.patch(
    `${API}/purchase-orders/${id}`,
    data,
    authHeader(token)
  );
  return res.data;
}

export async function approvePurchaseOrder(token, id) {
  const res = await axios.post(
    `${API}/purchase-orders/${id}/approve`,
    {},
    authHeader(token)
  );
  return res.data;
}

export async function receivePurchaseOrder(token, id, data) {
  const res = await axios.post(
    `${API}/purchase-orders/${id}/receive`,
    data,
    authHeader(token)
  );
  return res.data;
}